import React, { useEffect, useState, useMemo } from "react";

import SearchButton from "../../../components/buttons/search/search-btn";
import { newCompanyStatus } from "../companyRequest/userStatus";
import {
  user_company_list,
  send_bulk_emails,
} from "../admin.api";
import Notification from "../companyRequest/notification/notification";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import Pagination from "../../../components/table/Pagination";
import TextEditer from "../../../components/inputs/texteditor";
import "./view.css";
import jwtDecode from "jwt-decode";
import moment from "moment";

const getStatusInfo = (status) => {
  const statusMap = {
    0: { label: "Pending", class: "pending", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    1: { label: "Submitted", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg> },
    2: { label: "Accepted", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
    3: { label: "SA Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> },
    4: { label: "Rejected", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> },
    5: { label: "Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4m0 4h.01"></path></svg> },
    6: { label: "Agreement", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> },
    7: { label: "Ongoing", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    8: { label: "Completed", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
  };
  return statusMap[status] || { label: "Unknown", class: "secondary", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> };
};

export default function BulkEmail(props) {
  const [data, setData] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [emailFormData, setEmailFormData] = useState({
    subject: '',
    body_html: '',
    metadata: {
      campaign: '',
      priority: 'normal'
    }
  });

  // Pagination settings (same as CustomTable)
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState('all');
  const [showFilters, setShowFilters] = useState(false);

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleSelectAll = () => {
    console.log('handleSelectAll called, current selectAll:', selectAll);
    if (selectAll) {
      console.log('Deselecting all');
      setSelectedRows([]);
      setSelectAll(false);
    } else {
      // Select all companies using unique row identifiers
      const allRowIdentifiers = data.map(item => `${item.user_id}-${item.id}`);
      console.log('Selecting all row identifiers:', allRowIdentifiers);
      setSelectedRows(allRowIdentifiers);
      setSelectAll(true);
    }
  };

  const handleUnselectAll = () => {
    console.log('handleUnselectAll called');
    setSelectedRows([]);
    setSelectAll(false);
  };

  const handleRowSelect = (userId, uniqueId) => {
    console.log('handleRowSelect called with userId:', userId, 'uniqueId:', uniqueId);
    console.log('Current selectedRows:', selectedRows);
    console.log('Data length:', data.length);
    
    // Find the specific company being selected
    const selectedCompany = data.find(item => item.user_id === userId && item.id === uniqueId);
    console.log('Selected company:', selectedCompany?.company_name, 'user_id:', userId, 'uniqueId:', uniqueId, 'email:', selectedCompany?.email, 'phone:', selectedCompany?.phone_no);

    // Create a truly unique identifier for this row
    const rowIdentifier = `${userId}-${uniqueId}`;
    
    // Toggle selection for this specific row only
    const newSelectedRows = selectedRows.includes(rowIdentifier) 
      ? selectedRows.filter(id => id !== rowIdentifier)  // Remove this row
      : [...selectedRows, rowIdentifier];  // Add this row
    
    console.log('New selectedRows:', newSelectedRows);
    setSelectedRows(newSelectedRows);
    
    // Update selectAll state
    const allRowIdentifiers = data.map(item => `${item.user_id}-${item.id}`);
    setSelectAll(newSelectedRows.length === allRowIdentifiers.length && 
                 newSelectedRows.every(id => allRowIdentifiers.includes(id)));
  };

  const getReuestList = (statusValue, pageNum = currentPage, pageSize = perPage) => {
    setIsActive(true);
    const effectiveStatus = statusValue !== undefined ? statusValue : activeStatus;
    let param = {
      type: "kerala",
      status: effectiveStatus === "" ? "" : effectiveStatus,
      page: pageNum,
      per_page: pageSize === "all" ? "all" : pageSize,
    };
    user_company_list(param, adminType)
      .then((resp) => {
        const rawData = resp?.data || (Array.isArray(resp) ? resp : []);
        console.log('Data loaded:', rawData);
        setData(rawData);
        const lastPage = resp?.last_page || resp?.pagination?.last_page || 1;
        setTotalPages(lastPage);
      })
      .finally(() => {
        setIsActive(false);
      });
  };

  const getStatusList = () => {
    setStatuses(newCompanyStatus);
  };

  const handleSearch = () => {
    // Reset to first page and fetch using current status
    setCurrentPage(1);
    getReuestList(activeStatus);
  };

  const manageStatus = (e) => {
    const value = e.target.value;
    setActiveStatus(value);
    // Immediately apply status filter and reset to first page
    setCurrentPage(1);
    getReuestList(value);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      getReuestList(activeStatus);
    }
  };

  const handlePerPageChange = (e) => {
    const newPerPage = e.target.value;
    setPerPage(newPerPage);
    setCurrentPage(1);
    getReuestList(activeStatus, 1, newPerPage);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getReuestList(activeStatus, page, perPage);
  };

  const handleSendEmail = () => {
    // Parse selected row identifiers to get actual company data
    const selectedCompanyIds = selectedRows.map(rowId => {
      const [userId, id] = rowId.split('-');
      return { user_id: parseInt(userId), id: parseInt(id) };
    });
    
    const selectedCompanies = data.filter(item => 
      selectedCompanyIds.some(comp => 
        comp.user_id === item.user_id && comp.id === item.id
      )
    );
    const emails = selectedCompanies.map(item => item.email).filter(email => email);

    if (emails.length === 0) {
      setSnackMessage("No valid email addresses found for selected companies");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    // Open email compose popup
    setShowEmailPopup(true);
  };

  const handleEmailSubmit = async () => {
    // Parse selected row identifiers to get actual company data
    const selectedCompanyIds = selectedRows.map(rowId => {
      const [userId, id] = rowId.split('-');
      return { user_id: parseInt(userId), id: parseInt(id) };
    });
    
    const selectedCompanies = data.filter(item => 
      selectedCompanyIds.some(comp => 
        comp.user_id === item.user_id && comp.id === item.id
      )
    );
    const userIds = selectedCompanies.map(item => item.user_id).filter(user_id => user_id);
    const applicationIds = selectedCompanies.map(item => item.id).filter(id => id);

    // Create FormData for multipart/form-data with file uploads
    const formData = new FormData();

    // Append all the email data
    formData.append('user_category', 'companies');

    // Append user_ids as array
    userIds.forEach((id) => {
      formData.append('user_ids[]', id);
    });

    // Append application_ids as array
    applicationIds.forEach((id) => {
      formData.append('application_id[]', id);
    });

    formData.append('subject', emailFormData.subject);
    formData.append('body_html', emailFormData.body_html);

    // Append metadata as array fields
    formData.append('metadata[campaign]', emailFormData.metadata.campaign);
    formData.append('metadata[priority]', emailFormData.metadata.priority);

    // Append files as array
    selectedFiles.forEach((file) => {
      formData.append('documents[]', file);
    });

    console.log('Sending email with FormData:', formData);

    try {
      setIsActive(true);
      // Call the bulk email API with FormData
      const response = await send_bulk_emails(formData);

      setSnackMessage(response.message || `Email sent to ${selectedCompanies.length} companies successfully!`);
      setIsSnackError(false);
      setSnackOpen(true);
      setShowEmailPopup(false);

      // Uncheck all rows after successful email send
      setSelectedRows([]);
      setSelectAll(false);

      // Reset form and files
      setEmailFormData({
        subject: '',
        body_html: '',
        metadata: {
          campaign: '',
          priority: 'normal'
        }
      });
      setSelectedFiles([]);
    } catch (error) {
      console.error('Error sending bulk email:', error);
      setSnackMessage(error.message || 'Failed to send emails. Please try again.');
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  const handleEmailCancel = () => {
    setShowEmailPopup(false);
    // Reset form and files
    setEmailFormData({
      subject: '',
      body_html: '',
      metadata: {
        campaign: '',
        priority: 'normal'
      }
    });
    setSelectedFiles([]);
  };

  const handleEmailFormChange = (field, value) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setEmailFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setEmailFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 5 * 1024 * 1024; // 5 MB

    const oversized = files.filter(f => f.size > maxSize);
    if (oversized.length > 0) {
      setSnackMessage(`File size must be less than 5 MB`);
      setIsSnackError(true);
      setSnackOpen(true);
      e.target.value = ''; // clear the file input
      return;
    }

    setSelectedFiles(files);
  };

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    getReuestList(activeStatus, currentPage, perPage);
  }, [currentPage, perPage]);

  useEffect(() => {
    getStatusList();
  }, []);

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button key={1} className="btn btn-sm btn-outline-primary" onClick={() => handlePageChange(1)}>1</button>
      );
      if (start > 2) pages.push(<span key="start-dots" className="px-1 text-primary">...</span>);
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm ${currentPage === i ? "btn-primary text-white" : "btn-outline-primary"}`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="end-dots" className="px-1 text-primary">...</span>);
      pages.push(
        <button key={totalPages} className="btn btn-sm btn-outline-primary" onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
      );
    }

    return pages;
  };

  // Custom table component with pagination (same pattern as CustomTable)
  const CustomTableWithCheckbox = ({ data, columns }) => {
    return (
      <>
        <div className="table-responsive">
          <table className="table-bordered" style={{ width: '100%' }}>
            <thead className="thead-white thed">
              <tr>
                {columns.map((item, index) => (
                  <td
                    key={index}
                    className={
                      item.type === "status"
                        ? "statuscoloum"
                        : item.type === "notification"
                          ? "messagecoloum"
                          : item.type === "dynId"
                            ? "noFieldTableWidth"
                            : ""
                    }
                    style={{ color: "white", backgroundColor: "#666" }}
                  >
                    {item.title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody style={{ borderRight: "1px solid black" }}>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    {columns.map((column, colIndex) => (
                      <td key={colIndex}>
                        {column.field === "select" ? (
                          <input
                            key={`checkbox-${item.user_id}-${item.id}-${index}`} // Ensure unique key
                            type="checkbox"
                            checked={selectedRows.includes(`${item.user_id}-${item.id}`)}
                            onChange={(e) => {
                              e.stopPropagation();
                              console.log('Checkbox clicked for company:', item.company_name, 'user_id:', item.user_id, 'id:', item.id, 'email:', item.email, 'phone:', item.phone_no, 'Checked:', e.target.checked);
                              handleRowSelect(item.user_id, item.id);
                            }}
                            style={{ cursor: 'pointer' }}
                          />
                        ) : column.type === "fullDate" ? (
                          item[column.field]
                            ? moment(item[column.field]).format("DD-MM-YYYY")
                            : ""
                        ) : column.type === "notification" ? (
                          <div
                            className="notificationContainer"
                            onClick={(e) => {
                              if (props.handleNotification) {
                                props.handleNotification(item);
                              }
                            }}
                          >
                            <span className={item[column.field] === 1 ? "activenoti" : "notificationItem"}>
                              🔔
                            </span>
                          </div>
                        ) : column.type === "regstatusType" ? (
                          <div className={getStatusClass(parseInt(item[column.field]))}>
                            {getStatusTitle(parseInt(item[column.field]))}
                          </div>
                        ) : column.render ? (
                          column.render(item)
                        ) : (
                          item[column.field] || ""
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    style={{ textAlign: "center" }}
                    colSpan={columns.length}
                  >
                    No Records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="d-flex justify-content-between align-items-center mt-4">
          <div className="flex-grow-1"></div>
          <div className="btn-group">
            <button className="btn btn-sm btn-outline-primary" disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>
              Prev
            </button>
            {renderPagination()}
            <button className="btn btn-sm btn-outline-primary" disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>
              Next
            </button>
          </div>
          <div className="flex-grow-1 d-flex justify-content-end">
            <select className="form-control form-control-sm w-auto ml-2" value={perPage} onChange={handlePerPageChange} style={{ fontSize: "8px", height: "31px" }}>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="all">All</option>
            </select>
          </div>
        </div>
      </>
    );
  };

  const getStatusClass = (status) => {
    const statusClasses = {
      0: "pending",
      1: "inprogress",
      2: "Accepted",
      3: "SA Reverted",
      4: "Rejected",
      5: "Reverted",
      6: "agrementexecution",
      7: "Ongoing Project"
    };
    return statusClasses[status] || "";
  };

  const getStatusTitle = (status) => {
    const statusTitles = {
      0: "Pending",
      1: "Submitted",
      2: "Accepted",
      3: "SA Reverted",
      4: "Rejected",
      5: "Reverted",
      6: "Agreement Execution",
      7: "Ongoing Project"
    };
    return statusTitles[status] || "";
  };

  let tableColumns = [
    { title: "Select", field: "select" },
    { title: "Company Name", field: "company_name" },
    { title: "Application ID", field: "unique_application_ref_no" },
    { title: "Email", field: "email" },
    { title: "Phone Number", field: "phone_no" },
    {
      title: "Application Status",
      field: "project_status",
      render: (row) => {
        const statusInfo = getStatusInfo(row.project_status ?? row.application_status);
        return (
          <span className={`status-badge ${statusInfo.class}`}>
            <span className="status-icon">{statusInfo.icon}</span>
            <span className="status-label">{statusInfo.label}</span>
          </span>
        );
      },
    },
  ];

  return (
    <div>
      <div className="container-fluid mt-4">
        <Snackbar
          message={snackMessage}
          error={isSnackError}
          open={snackOpen}
          close={snackbarClose}
        />

        <Loader open={isActive} />
        <div className="card shadow-sm">
          <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <b>Bulk Email - Kerala Companies</b>
            </h5>
            <div className="d-flex gap-2">
              <button
                className="btn btn-primary btn-sm"
                onClick={handleSelectAll}
              >
                Select All
              </button>
              {selectedRows.length > 0 && (
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={handleUnselectAll}
                >
                  Unselect All
                </button>
              )}
              {selectedRows.length > 0 && (
                <button
                  className="btn btn-primary btn-sm search-style border-0 text-white"
                  onClick={handleSendEmail}
                >
                  Send Email ({selectedRows.length})
                </button>
              )}
              <button
                className={`filter-icon-btn ${showFilters ? "active" : ""}`}
                onClick={() => setShowFilters(!showFilters)}
                title="Toggle Filters"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                </svg>
              </button>
            </div>
          </div>

          <div className="card-body pt-0">
            <div className={`filter-container ${showFilters ? "show" : ""}`}>
              <div className="row align-items-end">
                <div className="col-md-3">
                  <label className="form-label small">Status</label>
                  <select
                    className="form-control filter-select"
                    onChange={(e) => manageStatus(e)}
                    value={activeStatus}
                  >
                    <option value={""}>Select Status</option>
                    {statuses.map((item) => (
                      <option
                        key={item.user_status_code}
                        value={item.user_status_code}
                      >
                        {item.user_status_title}
                      </option>
                    ))}
                    <option value={7}>Ongoing Projects</option>
                    <option value={6}>Agreement Execution</option>
                  </select>
                </div>
                <div className="col-md-3 d-flex gap-2">
                  <button className="filter-action-btn" title="Reset Filters" onClick={() => { setActiveStatus(""); setCurrentPage(1); getReuestList(""); }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                      <path d="M3 3v5h5"></path>
                    </svg>
                  </button>
                  <button className="filter-action-btn close-btn" title="Close Filters" onClick={() => setShowFilters(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <small className="text-muted">
                {selectedRows.length} of {data.length} companies selected
              </small>
            </div>

            <CustomTableWithCheckbox
              data={data}
              columns={tableColumns}
              handleNotification={props.handleNotification}
            />
          </div>
        </div>
      </div>

      {/* Email Compose Popup */}
      {showEmailPopup && (
        <div className="modal-backdrop" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            paddingLeft: '20px',
            borderRadius: '8px',
            width: '100%',
            maxWidth: '900px',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div className="modal-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <h5 className="modal-title">Compose Email</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleEmailCancel}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '24px',
                  cursor: 'pointer',
                  marginBottom: '10px',
                  fontWeight: 'semibold',
                  opacity: 1,
                  filter: 'none'
                }}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">To: {selectedRows.length} companies selected</label>
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Subject <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={emailFormData.subject}
                  onChange={(e) => handleEmailFormChange('subject', e.target.value)}
                  placeholder="Enter email subject"
                />
              </div>

              <div className="mb-3">
                <TextEditer
                  label={
                    <>
                      Message <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  value={emailFormData.body_html}
                  onChange={(value) => handleEmailFormChange('body_html', value)}
                  required={true}
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Campaign</label>
                  <input
                    type="text"
                    className="form-control"
                    value={emailFormData.metadata.campaign}
                    onChange={(e) => handleEmailFormChange('metadata.campaign', e.target.value)}
                    placeholder="Campaign name"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Priority</label>
                  <select
                    className="form-select"
                    value={emailFormData.metadata.priority}
                    onChange={(e) => handleEmailFormChange('metadata.priority', e.target.value)}
                  >
                    <option value="normal">Normal</option>
                    <option value="high">High</option>
                    <option value="low">Low</option>
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Attachments</label>
                <input
                  type="file"
                  className="form-control"
                  multiple
                  onChange={handleFileChange}
                />
                {selectedFiles.length > 0 && (
                  <div className="mt-2">
                    <small className="text-muted">Selected files:</small>
                    {selectedFiles.map((file, index) => (
                      <div key={index} className="d-flex justify-content-between align-items-center mt-1">
                        <small className="text-primary">{file.name} ({(file.size / 1024).toFixed(2)} KB)</small>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeFile(index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer" style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              marginTop: '20px'
            }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleEmailCancel}
                style={{ minWidth: 120, height: 40 }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleEmailSubmit}
                style={{ minWidth: 120, height: 40 }}
                disabled={!emailFormData.subject || !emailFormData.body_html}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
